import { LinkLegendComponent } from "./layer-legend/link-legend/link-legend.component";
import { ICustomLegend } from "./layer-legend/models/legend-models";

export class LayerListConfig {
    // eslint-disable-next-line sonarjs/public-static-readonly
    static model = [
        {
            id: "transportplanerakarta",
            config: [
                {
                    id: "tpl-destineringsomraden",
                    name: "Destineringsområden",
                    nodes: [
                        {
                            id: "tpl-destineringsomraden-ytor",
                            name: "Destineringsområdeytor",
                            layerid: "Destineringsomraden",
                            sublayerid: 0
                        }
                    ]
                },
                {
                    id: "tpl-admingranser",
                    name: "Administrativa gränser",
                    nodes: [
                        {
                            id: "tpl-admingrans-vk-omrade",
                            name: "Virkesköpsområden",
                            layerid: "VerkGemAdminGrans",
                            sublayerid: 0
                        },
                        {
                            id: "tpl-admingrans-mo-omrade",
                            name: "Marknadsområden",
                            layerid: "VerkGemAdminGrans",
                            sublayerid: 1
                        },
                        {
                            id: "tpl-admingrans-ro-omrade",
                            name: "Regioner",
                            layerid: "VerkGemAdminGrans",
                            sublayerid: 2
                        },
                        {
                            id: "tpl-admingrans-po-omrade",
                            name: "Produktionsområden",
                            layerid: "VerkGemAdminGrans",
                            sublayerid: 3
                        },
                        {
                            id: "tpl-admingrans-balansomraden",
                            name: "Balansområden",
                            layerid: "VerkGemAdminGrans",
                            sublayerid: 4
                        },
                        {
                            id: "tpl-admingrans-planeraromraden",
                            name: "Planerarområde",
                            layerid: "VerkGemAdminGrans",
                            sublayerid: 7
                        },
                        {
                            id: "tpl-admingrans-lld",
                            name: "LLD",
                            layerid: "VerkGemLLD",
                            sublayerid: 0
                        },
                        {
                            id: "tpl-admingrans-lkf",
                            name: "LKF",
                            layerid: "VerkGemLKF",
                            sublayerid: 0
                        },
                        {
                            id: "tpl-admingrans-fastigheter",
                            name: "Sveaskog Fastigheter",
                            layerid: "VerkGemFastigheter",
                            sublayerid: 0
                        },
                        {
                            id: "tpl-admingrans-samfalligheter",
                            name: "Sveaskog Samfälligheter",
                            layerid: "VerkGemSamfalligheter",
                            sublayerid: 0
                        }
                    ]
                },
                {
                    id: "tpl-vagar",
                    name: "Vägar",
                    nodes: [
                        {
                            id: "tpl-vagar-es",
                            name: "Vägar (ES)",
                            layerid: "Vagar",
                            sublayerid: 0
                        },
                        {
                            id: "tpl-vagnamn",
                            name: "Vägnamn",
                            layerid: "Vagar",
                            sublayerid: 8
                        },
                        {
                            id: "tpl-vagar-bas",
                            name: "Basvägar",
                            layerid: "Vagar",
                            sublayerid: 1
                        },
                        {
                            id: "tpl-vagar-ovriga",
                            name: "Övriga vägar",
                            layerid: "Vagar",
                            sublayerid: 2
                        },
                        {
                            id: "tpl-vagar-planerade",
                            name: "Planerade vägar",
                            layerid: "VFS_PlaneradVag",
                            sublayerid: 0
                        },
                        {
                            id: "tpl-vagar-planerade-fardigstalld",
                            name: "Planerade vägar (färdigställd)",
                            layerid: "VFS_PlaneradVag",
                            sublayerid: 1
                        }
                    ]
                },
                {
                    id: "tpl-transportomraden",
                    name: "Transportområden",
                    nodes: [
                        {
                            id: "tpl-transportomraden-ytor",
                            name: "Transportsområdeytor",
                            layerid: "Transportomraden",
                            sublayerid: 0
                        }
                    ]
                },
                {
                    id: "tpl-ovriga",
                    name: "Övriga",
                    nodes: [
                        {
                            id: "tpl-smittadzon",
                            name: "Smittad zon",
                            layerid: "smittad_zon_sjv",
                            sublayerid: 0
                        },
                        {
                            id: "tpl-dronarbilder",
                            name: "Drönarortofoton",
                            nodes: [
                                {
                                    id: "tpl-dronarbilder-index",
                                    name: "Index",
                                    layerid: "Drone",
                                    sublayerid: 0
                                },
                                {
                                    id: "tpl-dronarbilder-bilder",
                                    name: "Drönarbilder",
                                    layerid: "Drone",
                                    sublayerid: 1
                                }
                            ]
                        },
                        {
                            id: "tpl-vindkraftverk",
                            name: "Vindkraftverk",
                            nodes: [
                                {
                                    id: "tpl-projektomrade-for-vindkraft",
                                    name: "Projektområde för vindkraft",
                                    layerid: "VerkGemFaktaExternVindkraft",
                                    sublayerid: 0
                                },
                                {
                                    id: "tpl-belastningar-vindkraft",
                                    name: "Vindkraft",
                                    layerid: "VerkGemFaktaBelastningar",
                                    sublayerid: 13
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            id: "dso",
            config: [
                {
                    id: "dso-destineringsomraden",
                    name: "Destineringsområden",
                    nodes: [
                        {
                            id: "dso-destineringsomraden-ytor",
                            name: "Destineringsområdeytor",
                            layerid: "Destineringsomraden",
                            sublayerid: 0
                        }
                    ]
                },
                {
                    id: "dso-admingranser",
                    name: "Administrativa gränser",
                    nodes: [
                        {
                            id: "dso-admingrans-vk-omrade",
                            name: "Virkesköpsområden",
                            layerid: "VerkGemAdminGrans",
                            sublayerid: 0
                        },
                        {
                            id: "dso-admingrans-mo-omrade",
                            name: "Marknadsområden",
                            layerid: "VerkGemAdminGrans",
                            sublayerid: 1
                        },
                        {
                            id: "dso-admingrans-ro-omrade",
                            name: "Regioner",
                            layerid: "VerkGemAdminGrans",
                            sublayerid: 2
                        },
                        {
                            id: "dso-admingrans-po-omrade",
                            name: "Produktionsområden",
                            layerid: "VerkGemAdminGrans",
                            sublayerid: 3
                        },
                        {
                            id: "dso-admingrans-balansomraden",
                            name: "Balansområden",
                            layerid: "VerkGemAdminGrans",
                            sublayerid: 4
                        },
                        {
                            id: "dso-admingrans-planeraromraden",
                            name: "Planerarområde",
                            layerid: "VerkGemAdminGrans",
                            sublayerid: 7
                        },
                        {
                            id: "dso-admingrans-lld",
                            name: "LLD",
                            layerid: "VerkGemLLD",
                            sublayerid: 0
                        },
                        {
                            id: "dso-admingrans-lkf",
                            name: "LKF",
                            layerid: "VerkGemLKF",
                            sublayerid: 0
                        },
                        {
                            id: "dso-admingrans-fastigheter",
                            name: "Sveaskog Fastigheter",
                            layerid: "VerkGemFastigheter",
                            sublayerid: 0
                        }
                    ]
                },
                {
                    id: "dso-vagar",
                    name: "Vägar",
                    nodes: [
                        {
                            id: "dso-vagar-es",
                            name: "Vägar (ES)",
                            layerid: "Vagar",
                            sublayerid: 0
                        },
                        {
                            id: "dso-vagnamn",
                            name: "Vägnamn",
                            layerid: "Vagar",
                            sublayerid: 8
                        },
                        {
                            id: "dso-vagar-bas",
                            name: "Basvägar",
                            layerid: "Vagar",
                            sublayerid: 1
                        },
                        {
                            id: "dso-vagar-ovriga",
                            name: "Övriga vägar",
                            layerid: "Vagar",
                            sublayerid: 2
                        },
                        {
                            id: "dso-vagar-planerade",
                            name: "Planerade vägar",
                            layerid: "VFS_PlaneradVag",
                            sublayerid: 0
                        },
                        {
                            id: "dso-vagar-planerade-fardigstalld",
                            name: "Planerade vägar (färdigställd)",
                            layerid: "VFS_PlaneradVag",
                            sublayerid: 1
                        }
                    ]
                }
            ]
        },
        {
            id: "transportforetagkarta",
            config: [
                {
                    id: "tf-admingranser",
                    name: "Administrativa gränser",
                    nodes: [
                        {
                            id: "tf-admingrans-vk-omrade",
                            name: "Virkesköpsområden",
                            layerid: "VerkGemAdminGrans",
                            sublayerid: 0
                        },
                        {
                            id: "tf-admingrans-mo-omrade",
                            name: "Marknadsområden",
                            layerid: "VerkGemAdminGrans",
                            sublayerid: 1
                        },
                        {
                            id: "tf-admingrans-ro-omrade",
                            name: "Regioner",
                            layerid: "VerkGemAdminGrans",
                            sublayerid: 2
                        },
                        {
                            id: "tf-admingrans-po-omrade",
                            name: "Produktionsområden",
                            layerid: "VerkGemAdminGrans",
                            sublayerid: 3
                        },
                        {
                            id: "tf-admingrans-balansomraden",
                            name: "Balansområden",
                            layerid: "VerkGemAdminGrans",
                            sublayerid: 4
                        },
                        {
                            id: "tf-admingrans-planeraromraden",
                            name: "Planerarområde",
                            layerid: "VerkGemAdminGrans",
                            sublayerid: 7
                        },
                        {
                            id: "tf-admingrans-lld",
                            name: "LLD",
                            layerid: "VerkGemLLD",
                            sublayerid: 0
                        },
                        {
                            id: "tf-admingrans-lkf",
                            name: "LKF",
                            layerid: "VerkGemLKF",
                            sublayerid: 0
                        },
                        {
                            id: "tf-admingrans-fastigheter",
                            name: "Sveaskog Fastigheter",
                            layerid: "VerkGemFastigheter",
                            sublayerid: 0
                        }
                    ]
                },
                {
                    id: "tf-vagar",
                    name: "Vägar",
                    nodes: [
                        {
                            id: "tf-vagar-es",
                            name: "Vägar (ES)",
                            layerid: "Vagar",
                            sublayerid: 0
                        },
                        {
                            id: "tf-vagnamn",
                            name: "Vägnamn",
                            layerid: "Vagar",
                            sublayerid: 8
                        },
                        {
                            id: "tf-vagar-bas",
                            name: "Basvägar",
                            layerid: "Vagar",
                            sublayerid: 1
                        },
                        {
                            id: "tf-vagar-ovriga",
                            name: "Övriga vägar",
                            layerid: "Vagar",
                            sublayerid: 2
                        },
                        {
                            id: "tf-vagar-planerade",
                            name: "Planerade vägar",
                            layerid: "VFS_PlaneradVag",
                            sublayerid: 0
                        },
                        {
                            id: "tf-vagar-planerade-fardigstalld",
                            name: "Planerade vägar (färdigställd)",
                            layerid: "VFS_PlaneradVag",
                            sublayerid: 1
                        }
                    ]
                },
                {
                    id: "tf-transportomraden",
                    name: "Transportområden",
                    nodes: [
                        {
                            id: "tf-transportomraden-ytor",
                            name: "Transportsområdeytor",
                            layerid: "Transportomraden",
                            sublayerid: 0
                        }
                    ]
                }
            ]
        },
        {
            id: "ppl",
            config: [
                {
                    id: "ppl-metriafastighetsgranser",
                    name: "Metria Fastighetsgränser",
                    layerid: "MetriaFastighetsgranser",
                    nodes: [
                        {
                            id: "ppl-metria-fastigheter",
                            name: "Fastigheter",
                            layerid: "MetriaFastighetsgranser",
                            sublayerid: 0
                        }
                    ]
                },
                {
                    id: "ppl-naturhansyn",
                    name: "Naturhänsyn",
                    nodes: [
                        {
                            id: "ppl-naturhansyn-detalj-es",
                            name: "Detaljhänsyn (ES)",
                            layerid: "Naturhansyn",
                            sublayerid: 0,
                            nodes: [
                                {
                                    id: "ppl-naturhansyn-detalj-es-punkter",
                                    name: "Punkter",
                                    layerid: "Naturhansyn",
                                    sublayerid: 1
                                },
                                {
                                    id: "ppl-naturhansyn-detalj-es-linjer",
                                    name: "Linjer",
                                    layerid: "Naturhansyn",
                                    sublayerid: 2
                                },
                                {
                                    id: "ppl-naturhansyn-detalj-es-ytor",
                                    name: "Ytor",
                                    layerid: "Naturhansyn",
                                    sublayerid: 3,
                                    nodes: [
                                        {
                                            id: "ppl-naturhansyn-detalj-es-yta-ytter",
                                            name: "Yttergräns",
                                            layerid: "Naturhansyn",
                                            sublayerid: 4
                                        },
                                        {
                                            id: "ppl-naturhansyn-detalj-es-yta-fyllning",
                                            name: "Fyllning",
                                            layerid: "Naturhansyn",
                                            sublayerid: 5
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            id: "ppl-naturhansyn-detalj-vk",
                            name: "Detaljhänsyn (VK)",
                            layerid: "Naturhansyn",
                            sublayerid: 6,
                            nodes: [
                                {
                                    id: "ppl-naturhansyn-detalj-vk-punkter",
                                    name: "Punkter",
                                    layerid: "Naturhansyn",
                                    sublayerid: 7
                                },
                                {
                                    id: "ppl-naturhansyn-detalj-vk-linjer",
                                    name: "Linjer",
                                    layerid: "Naturhansyn",
                                    sublayerid: 8
                                },
                                {
                                    id: "ppl-naturhansyn-detalj-vk-ytor",
                                    name: "Ytor",
                                    layerid: "Naturhansyn",
                                    sublayerid: 9,
                                    nodes: [
                                        {
                                            id: "ppl-naturhansyn-detalj-vk-yta-ytter",
                                            name: "Yttergräns",
                                            layerid: "Naturhansyn",
                                            sublayerid: 11
                                        },
                                        {
                                            id: "ppl-naturhansyn-detalj-vk-yta-fyllning",
                                            name: "Fyllning",
                                            layerid: "Naturhansyn",
                                            sublayerid: 10
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            id: "ppl-naturhansyn-naturvardskogar",
                            name: "Naturvårdsskogar",
                            layerid: "Naturhansyn",
                            sublayerid: 12
                        }
                    ]
                },
                {
                    id: "ppl-restriktioner",
                    name: "Restriktioner",
                    nodes: [
                        {
                            id: "ppl-restriktioner-extern",
                            name: "Externa",
                            layerid: "Restriktioner",
                            sublayerid: 0,
                            nodes: [
                                {
                                    id: "ppl-restriktioner-extern-100",
                                    name: "< 1:100 000",
                                    layerid: "Restriktioner",
                                    sublayerid: 1
                                },
                                {
                                    id: "ppl-restriktioner-extern-40",
                                    name: "< 1:40 000",
                                    layerid: "Restriktioner",
                                    sublayerid: 3
                                }
                            ]
                        },
                        {
                            id: "ppl-restriktioner-svea",
                            name: "Sveaskog",
                            layerid: "Restriktioner",
                            sublayerid: 4,
                            nodes: [
                                {
                                    id: "ppl-restriktioner-extern-100",
                                    name: "< 1:100 000",
                                    layerid: "Restriktioner",
                                    sublayerid: 5
                                },
                                {
                                    id: "ppl-restriktioner-extern-50",
                                    name: "< 1:50 000",
                                    layerid: "Restriktioner",
                                    sublayerid: 6
                                }
                            ]
                        },
                        {
                            id: "ppl-restriktioner-ifl",
                            name: "IntactForestLandscape(< 1:100.000)",
                            layerid: "Restriktioner",
                            sublayerid: 7
                        },
                        {
                            id: "ppl-restriktioner-artforekomster",
                            name: "Artförekomster",
                            layerid: "Restriktioner",
                            sublayerid: 9
                        }
                    ]
                },
                {
                    id: "ppl-admingranser",
                    name: "Administrativa gränser",
                    nodes: [
                        {
                            id: "ppl-admingrans-vk-omrade",
                            name: "Virkesköpsområden",
                            layerid: "VerkGemAdminGrans",
                            sublayerid: 0
                        },
                        {
                            id: "ppl-admingrans-mo-omrade",
                            name: "Marknadsområden",
                            layerid: "VerkGemAdminGrans",
                            sublayerid: 1
                        },
                        {
                            id: "ppl-admingrans-ro-omrade",
                            name: "Regioner",
                            layerid: "VerkGemAdminGrans",
                            sublayerid: 2
                        },
                        {
                            id: "ppl-admingrans-po-omrade",
                            name: "Produktionsområden",
                            layerid: "VerkGemAdminGrans",
                            sublayerid: 3
                        },
                        {
                            id: "ppl-admingrans-balansomraden",
                            name: "Balansområden",
                            layerid: "VerkGemAdminGrans",
                            sublayerid: 4
                        },
                        {
                            id: "ppl-admingrans-planeraromraden",
                            name: "Planerarområde",
                            layerid: "VerkGemAdminGrans",
                            sublayerid: 7
                        },
                        {
                            id: "ppl-admingrans-lld",
                            name: "LLD",
                            layerid: "VerkGemLLD",
                            sublayerid: 0
                        },
                        {
                            id: "ppl-admingrans-lkf",
                            name: "LKF",
                            layerid: "VerkGemLKF",
                            sublayerid: 0
                        },
                        {
                            id: "ppl-admingrans-fastigheter",
                            name: "Sveaskog Fastigheter",
                            layerid: "VerkGemFastigheter",
                            sublayerid: 0
                        },
                        {
                            id: "ppl-admingrans-samfalligheter",
                            name: "Sveaskog Samfälligheter",
                            layerid: "VerkGemSamfalligheter",
                            sublayerid: 0
                        },
                        {
                            id: "ppl-admingrans-samebyar",
                            name: "Samebyar",
                            layerid: "Renskotselomraden",
                            sublayerid: 0
                        }
                    ]
                },
                {
                    id: "ppl-forn-kultur",
                    name: "Forn- och kulturminnen",
                    nodes: [
                        {
                            id: "ppl-forn-kultur-punkt-raä",
                            name: "Fornminne punkt RAÄ",
                            layerid: "FornKulturminnen",
                            sublayerid: 0
                        },
                        {
                            id: "ppl-forn-kultur-linje-raä",
                            name: "Fornminne linje RAÄ",
                            layerid: "FornKulturminnen",
                            sublayerid: 1
                        },
                        {
                            id: "ppl-forn-kultur-yta-raä",
                            name: "Fornminne yta RAÄ",
                            layerid: "FornKulturminnen",
                            sublayerid: 2
                        },
                        {
                            id: "ppl-forn-kultur-skog-hist-punkt",
                            name: "Skog o historia, punkt",
                            layerid: "FornKulturminnen",
                            sublayerid: 3
                        },
                        {
                            id: "ppl-forn-kultur-skog-hist-linje",
                            name: "Skog o historia, linje",
                            layerid: "FornKulturminnen",
                            sublayerid: 4
                        },
                        {
                            id: "ppl-forn-kultur-skog-hist-yta",
                            name: "Skog o historia, yta",
                            layerid: "FornKulturminnen",
                            sublayerid: 5
                        }
                    ]
                },
                {
                    id: "ppl-vagar",
                    name: "Vägar",
                    nodes: [
                        {
                            id: "ppl-vagar-es",
                            name: "Vägar (ES)",
                            layerid: "Vagar",
                            sublayerid: 0
                        },
                        {
                            id: "ppl-vagnamn",
                            name: "Vägnamn",
                            layerid: "Vagar",
                            sublayerid: 8
                        },
                        {
                            id: "ppl-vagar-bas",
                            name: "Basvägar",
                            layerid: "Vagar",
                            sublayerid: 1
                        },
                        {
                            id: "ppl-vagar-hubudbasstrak",
                            name: "Huvudbasstråk",
                            layerid: "Vagar",
                            sublayerid: 9
                        },
                        {
                            id: "ppl-vagar-ovriga",
                            name: "Övriga vägar",
                            layerid: "Vagar",
                            sublayerid: 2
                        },
                        {
                            id: "ppl-vagar-planerade",
                            name: "Planerade vägar",
                            layerid: "VFS_PlaneradVag",
                            sublayerid: 0
                        },
                        {
                            id: "ppl-vagar-planerade-fardigstalld",
                            name: "Planerade vägar (färdigställd)",
                            layerid: "VFS_PlaneradVag",
                            sublayerid: 1
                        },
                        {
                            id: "ppl-vagar-vk",
                            name: "Vägar (VK)",
                            layerid: "Vagar",
                            sublayerid: 4
                        },
                        {
                            id: "ppl-vagar-drivningspunkter-es",
                            name: "Drivningspunkter (ES)",
                            layerid: "Vagar",
                            sublayerid: 5
                        },
                        {
                            id: "ppl-vagar-drivningspunkter-vk",
                            name: "Drivningspunkter (VK)",
                            layerid: "Vagar",
                            sublayerid: 6
                        },
                        {
                            id: "ppl-vagar-drivningslinjer-vk",
                            name: "Drivningslinjer (VK)",
                            layerid: "Vagar",
                            sublayerid: 7
                        }
                    ]
                },
                {
                    id: "ppl-laserprodukter",
                    name: "Laserprodukter",
                    customLegend: {
                        component: LinkLegendComponent,
                        inputs: {
                            text: "Beskrivning laserprodukter",

                            url: "https://sveaskog.sharepoint.com/sites/Glantan/SiteCollectionDocuments/Forms" +
                                "/AllItems.aspx?id=%2Fsites%2FGlantan%2FSiteCollectionDocuments%2FVirkesk%C3%B6p%2Fbeskrivning%5Frasterprodukter%2Epdf&viewid" +
                                "=9ab85964%2D790a%2D4e46%2D910f%2De0223ad35cd7&parent=%2Fsites%2FGlantan%2FSiteCollectionDocuments%2FVirkesk%C3%B6p"
                        }
                    } as ICustomLegend,
                    nodes: [
                        {
                            id: "ppl-laserprodukter-lutningsklass",
                            name: "Lutningsklass",
                            layerid: "Laserprodukter",
                            sublayerid: 2
                        },
                        {
                            id: "ppl-laserprodukter-skuggad",
                            name: "Skuggad höjd",
                            layerid: "Laserprodukter",
                            sublayerid: 4
                        },
                        {
                            id: "ppl-laserprodukter-trahojdraster",
                            name: "Trädhöjdsraster",
                            layerid: "Laserprodukter",
                            sublayerid: 3
                        },
                        {
                            id: "ppl-laserprodukter-skuggadkronmodell",
                            name: "Skuggad kronmodell",
                            layerid: "Laserprodukter",
                            sublayerid: 1
                        },
                        {
                            id: "ppl-laserprodukter-markvattenslu",
                            name: "Markfuktighet hela Sverige (SLU)",
                            layerid: "Laserprodukter",
                            sublayerid: 9
                        },
                        {
                            id: "ppl-laserprodukter-markfuktighet",
                            name: "Markfuktighet egen skog",
                            layerid: "Laserprodukter",
                            sublayerid: 5,
                            nodes: [
                                {
                                    id: "ppl-laserprodukter-mkt-blot",
                                    name: "Mycket blötare",
                                    layerid: "Laserprodukter",
                                    sublayerid: 8
                                },
                                {
                                    id: "ppl-laserprodukter-blot",
                                    name: "Blötare",
                                    layerid: "Laserprodukter",
                                    sublayerid: 7
                                },
                                {
                                    id: "ppl-laserprodukter-normalt",
                                    name: "Normalt",
                                    layerid: "Laserprodukter",
                                    sublayerid: 6
                                }
                            ]
                        },
                        {
                            id: "ppl-laserprodukter-kronslutenhet",
                            name: "Kronslutenhet",
                            layerid: "Laserprodukter",
                            sublayerid: 0
                        }
                    ]
                },
                {
                    id: "ppl-allmana-ytor-linjer-punkter",
                    name: "Allmänna ytor, linjer & punkter",
                    nodes: [
                        {
                            id: "ppl-aylp-punkter",
                            name: "Allmänna punkter",
                            layerid: "Allmanna_ytor_linjer_punkter",
                            sublayerid: 0
                        },
                        {
                            id: "ppl-aylp-linjer",
                            name: "Allmänna linjer",
                            layerid: "Allmanna_ytor_linjer_punkter",
                            sublayerid: 1
                        }
                    ]
                },
                {
                    id: "ppl-destineringsomraden",
                    name: "Destineringsområden",
                    nodes: [
                        {
                            id: "ppl-destineringsomraden-helgrot",
                            name: "Helgrot",
                            layerid: "Destineringsomraden",
                            sublayerid: 0
                        }
                    ]
                },
                {
                    id: "ppl-arbetsorder",
                    name: "Arbetsorder",
                    visible: false,
                    nodes: [
                        {
                            id: "ppl-stina-korstrak",
                            name: "Stina körstråk",
                            layerid: "StinaKorstrak",
                            visible: false,
                            nodes: [
                                {
                                    id: "ppl-stina-korstrak-backstrak-spokstrak",
                                    name: "Backstråk och spökstråk",
                                    layerid: "StinaKorstrak",
                                    sublayerid: 0,
                                    visible: false
                                },
                                {
                                    id: "ppl-stina-korstrak-skotare",
                                    name: "Körstråk Skotare",
                                    layerid: "StinaKorstrak",
                                    sublayerid: 1,
                                    visible: false,
                                    nodes: [
                                        {
                                            id: "ppl-stina-korstrak-skotare-korstrak",
                                            name: "Körstråk skotare",
                                            layerid: "StinaKorstrak",
                                            sublayerid: 2
                                        },
                                        {
                                            id: "ppl-stina-korstrak-skotare-ytterlinje",
                                            name: "Körstråksyta skotare ytterlinje",
                                            layerid: "StinaKorstrak",
                                            sublayerid: 3
                                        },
                                        {
                                            id: "ppl-stina-korstrak-skotare-fyllning",
                                            name: "Körstråksyta skotare fyllning",
                                            layerid: "StinaKorstrak",
                                            sublayerid: 4
                                        }
                                    ]
                                },
                                {
                                    id: "ppl-stina-korstrak-skordare",
                                    name: "Körstråk Skördare",
                                    layerid: "StinaKorstrak",
                                    sublayerid: 5,
                                    visible: false,
                                    nodes: [
                                        {
                                            id: "ppl-stina-korstrak-skordare-korstrak",
                                            name: "Körstråk skördare",
                                            layerid: "StinaKorstrak",
                                            sublayerid: 6
                                        },
                                        {
                                            id: "ppl-stina-korstrak-skordare-ytterlinje",
                                            name: "Körstråksyta skördare ytterlinje",
                                            layerid: "StinaKorstrak",
                                            sublayerid: 7
                                        },
                                        {
                                            id: "ppl-stina-korstrak-skordare-fyllning",
                                            name: "Körstråksyta skördare fyllning",
                                            layerid: "StinaKorstrak",
                                            sublayerid: 8
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            id: "ppl-stina-grotpunkter",
                            name: "Stina Grotpunkter",
                            layerid: "StinaGrotpunkter",
                            sublayerid: 0
                        },
                        {
                            id: "ppl-stina-hansyn",
                            name: "Stina hänsyn",
                            layerid: "StinaHansyn",
                            sublayerid: 0,
                            nodes: [
                                {
                                    id: "ppl-stina-hansyn-naturpunkt",
                                    name: "Naturhänsynspunkt",
                                    layerid: "StinaHansyn",
                                    sublayerid: 1
                                },
                                {
                                    id: "ppl-stina-hansyn-punkt",
                                    name: "Hänsynspunkt",
                                    layerid: "StinaHansyn",
                                    sublayerid: 2
                                },
                                {
                                    id: "ppl-stina-hansyn-linje",
                                    name: "Hänsynslinje",
                                    layerid: "StinaHansyn",
                                    sublayerid: 3
                                },
                                {
                                    id: "ppl-stina-hansyn-ytterlinje",
                                    name: "Hänsynsyta ytterlinje",
                                    layerid: "StinaHansyn",
                                    sublayerid: 4
                                },
                                {
                                    id: "ppl-stina-hansyn-fyllning",
                                    name: "Hänsynsyta fyllning",
                                    layerid: "StinaHansyn",
                                    sublayerid: 5
                                }
                            ]
                        },
                        {
                            id: "ppl-stina-egenritade",
                            name: "Stina egenritade objekt",
                            layerid: "StinaEgenritadeObjekt",
                            nodes: [
                                {
                                    id: "ppl-stina-egenritade-punkt",
                                    name: "Egenritad punkt",
                                    layerid: "StinaEgenritadeObjekt",
                                    sublayerid: 0
                                },
                                {
                                    id: "ppl-stina-egenritade-linje",
                                    name: "Egenritad linje",
                                    layerid: "StinaEgenritadeObjekt",
                                    sublayerid: 1
                                },
                                {
                                    id: "ppl-stina-egenritade-yta-ytterlinje",
                                    name: "Egenritad yta ytterlinje",
                                    layerid: "StinaEgenritadeObjekt",
                                    sublayerid: 2
                                },
                                {
                                    id: "ppl-stina-egenritade-yta-fyllning",
                                    name: "Egenritad yta fyllning",
                                    layerid: "StinaEgenritadeObjekt",
                                    sublayerid: 3
                                }
                            ]
                        }
                    ]
                },
                {
                    id: "ppl-mottagningsplatser",
                    name: "Mottagningsplatser",
                    nodes: [
                        {
                            id: "ppl-rask-mottagningsplatser",
                            name: "Mottagningsplatser",
                            layerid: "RaskMottagningsplatser",
                            sublayerid: 0
                        }
                    ]
                },
                {
                    id: "ppl-ovriga",
                    name: "Övriga",
                    nodes: [
                        {
                            id: "ppl-satellitbilder",
                            name: "Satellitbilder",
                            layerid: "Satellitbilder",
                            sublayerid: 0
                        },
                        {
                            id: "ppl-smittadzon",
                            name: "Smittad zon",
                            layerid: "smittad_zon_sjv",
                            sublayerid: 0
                        },
                        {
                            id: "ppl-dronarbilder",
                            name: "Drönarortofoton",
                            nodes: [
                                {
                                    id: "ppl-dronarbilder-index",
                                    name: "Index",
                                    layerid: "Drone",
                                    sublayerid: 0
                                },
                                {
                                    id: "ppl-dronarbilder-bilder",
                                    name: "Drönarbilder",
                                    layerid: "Drone",
                                    sublayerid: 1
                                }
                            ]
                        },
                        {
                            id: "ppl-vindkraftverk",
                            name: "Vindkraftverk",
                            nodes: [
                                {
                                    id: "ppl-projektomrade-for-vindkraft",
                                    name: "Projektområde för vindkraft",
                                    layerid: "VerkGemFaktaExternVindkraft",
                                    sublayerid: 0
                                },
                                {
                                    id: "ppl-belastningar-vindkraft",
                                    name: "Vindkraft",
                                    layerid: "VerkGemFaktaBelastningar",
                                    sublayerid: 13
                                }
                            ]
                        },
                        {
                            id: "ppl-orto-ir",
                            name: "IR ortofoto",
                            layerid: "Infrarodorto",
                            sublayerid: 3,
                            sublayerName: "metria:orto_ir"
                        }
                    ]
                },
                {
                    id: "ppl-sks-avverkningsanmalningar",
                    name: "SKS Avverkningsanmälningar",
                    nodes: [
                        {
                            id: "ppl-sks-avverkningsanmalan",
                            name: "Avverkningsanmälan",
                            layerid: "SKS_Avverkningsanmalningar",
                            sublayerid: 0
                        },
                        {
                            id: "ppl-sks-utford-avverkning",
                            name: "Utförd avverkning",
                            layerid: "SKS_UtfordAvverkning",
                            sublayerid: 1
                        }
                    ]
                }
            ]
        },
        {
            id: "virkeskop",
            config:
                [
                    {
                        id: "vk-collector",
                        name: "Field Maps",
                        nodes: [
                            {
                                id: "vk-coll-drivpunkt",
                                name: "Drivningspunkt",
                                layerid: "Collector",
                                sublayerid: 0
                            },
                            {
                                id: "vk-coll-hansyn-punkt",
                                name: "Punkthänsyn",
                                layerid: "Collector",
                                sublayerid: 1
                            },
                            {
                                id: "vk-coll-tips",
                                name: "Tips",
                                layerid: "Collector",
                                sublayerid: 2
                            },
                            {
                                id: "vk-coll-linje",
                                name: "Linje",
                                layerid: "Collector",
                                sublayerid: 3
                            },
                            {
                                id: "vk-coll-hansyn-linje",
                                name: "Linjehänsyn",
                                layerid: "Collector",
                                sublayerid: 4
                            },
                            {
                                id: "vk-coll-atgard-yta",
                                name: "Åtgärdsyta",
                                layerid: "Collector",
                                sublayerid: 5
                            },
                            {
                                id: "vk-coll-hansyn-yta",
                                name: "Hänsynsyta",
                                layerid: "Collector",
                                sublayerid: 6
                            }
                        ]
                    },
                    {
                        id: "vk-Springfield",
                        name: "Springfield",
                        nodes: [
                            {
                                id: "vk-spring-drivpunkt",
                                name: "Drivningspunkt",
                                layerid: "Springfield",
                                sublayerid: 0
                            },
                            {
                                id: "vk-spring-hansyn-punkt",
                                name: "Punkthänsyn",
                                layerid: "Springfield",
                                sublayerid: 1
                            },
                            {
                                id: "vk-spring-tips",
                                name: "Tips",
                                layerid: "Springfield",
                                sublayerid: 2
                            },
                            {
                                id: "vk-spring-linje",
                                name: "Linje",
                                layerid: "Springfield",
                                sublayerid: 3
                            },
                            {
                                id: "vk-spring-hansyn-linje",
                                name: "Linjehänsyn",
                                layerid: "Springfield",
                                sublayerid: 4
                            },
                            {
                                id: "vk-spring-atgard-yta",
                                name: "Åtgärdsyta",
                                layerid: "Springfield",
                                sublayerid: 5
                            },
                            {
                                id: "vk-spring-hansyn-yta",
                                name: "Hänsynsyta",
                                layerid: "Springfield",
                                sublayerid: 6
                            }
                        ]
                    },
                    {
                        id: "vk-arboreal",
                        name: "Arboreal",
                        nodes: [
                            {
                                id: "vk-provyta",
                                name: "Provyta",
                                layerid: "Arboreal",
                                sublayerid: 12
                            },
                            {
                                id: "vk-trad",
                                name: "Träd",
                                layerid: "Arboreal",
                                sublayerid: 13
                            }
                        ]
                    },
                    {
                        id: "vk",
                        name: "Virkesköp",
                        nodes: [
                            {
                                id: "vk-drivpunkt",
                                name: "Drivningspunkter",
                                layerid: "Virkeskop",
                                sublayerid: 0,
                                minScale: 24000
                            },
                            {
                                id: "vk-drivlinje",
                                name: "Drivningslinjer",
                                layerid: "Virkeskop",
                                sublayerid: 1
                            },
                            {
                                id: "vk-vag",
                                name: "Vägar",
                                layerid: "Virkeskop",
                                sublayerid: 2
                            },
                            {
                                id: "vk-hansyn-punkt",
                                name: "Detaljhänsyn punkter",
                                layerid: "Virkeskop",
                                sublayerid: 3
                            },
                            {
                                id: "vk-hansyn-linje",
                                name: "Detaljhänsyn linjer",
                                layerid: "Virkeskop",
                                sublayerid: 4
                            },
                            {
                                id: "vk-hansyn-ytor",
                                name: "Detaljhänsyn ytor",
                                layerid: "Virkeskop",
                                sublayerid: 5,
                                nodes: [
                                    {
                                        id: "vk-hansyn-ytor-fyllning",
                                        name: "Detaljhänsyn ytor fyllning",
                                        layerid: "Virkeskop",
                                        sublayerid: 6
                                    },
                                    {
                                        id: "vk-hansyn-ytor-ytter",
                                        name: "Detaljhänsyn ytor yttergräns",
                                        layerid: "Virkeskop",
                                        sublayerid: 7
                                    }
                                ]
                            },
                            {
                                id: "vk-atgarder",
                                name: "Åtgärder",
                                layerid: "Virkeskop",
                                sublayerid: 8,
                                nodes: [
                                    {
                                        id: "vk-atgarder-punkter",
                                        name: "Punkter",
                                        layerid: "Virkeskop",
                                        sublayerid: 9
                                    },
                                    {
                                        id: "vk-atgarder-ytterlinje",
                                        name: "Ytterlinje",
                                        layerid: "Virkeskop",
                                        sublayerid: 10
                                    },
                                    {
                                        id: "vk-atgarder-fyllning",
                                        name: "Fyllning",
                                        layerid: "Virkeskop",
                                        sublayerid: 11
                                    }
                                ]
                            },
                            {
                                id: "vk-atgarder-hist",
                                name: "Åtgärder (historiska)",
                                layerid: "Virkeskop_historiska",
                                sublayerid: 8,
                                nodes: [
                                    {
                                        id: "vk-atgarder-hist-punkter",
                                        name: "Punkter",
                                        layerid: "Virkeskop_historiska",
                                        sublayerid: 9
                                    },
                                    {
                                        id: "vk-atgarder-hist-ytterlinje",
                                        name: "Ytterlinje",
                                        layerid: "Virkeskop_historiska",
                                        sublayerid: 10
                                    },
                                    {
                                        id: "vk-atgarder-hist-fyllning",
                                        name: "Fyllning",
                                        layerid: "Virkeskop_historiska",
                                        sublayerid: 11
                                    }
                                ]
                            },
                            {
                                id: "vk-allmanna",
                                name: "Allmänna",
                                layerid: "Virkeskop",
                                sublayerid: 12,
                                nodes: [
                                    {
                                        id: "vk-allmanna-punkter",
                                        name: "Punkter",
                                        layerid: "Virkeskop",
                                        sublayerid: 13
                                    },
                                    {
                                        id: "vk-allmanna-linjer",
                                        name: "Linjer",
                                        layerid: "Virkeskop_historiska",
                                        sublayerid: 14
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        id: "vk-metriafastighetsgranser",
                        name: "Metria Fastighetsgränser",
                        layerid: "MetriaFastighetsgranser",
                        nodes: [
                            {
                                id: "vk-metria-fastigheter",
                                name: "Fastigheter",
                                layerid: "MetriaFastighetsgranser",
                                sublayerid: 0
                            }
                        ]
                    },
                    {
                        id: "vk-restriktioner",
                        name: "Restriktioner",
                        nodes: [
                            {
                                id: "vk-restriktioner-extern",
                                name: "Externa",
                                layerid: "Restriktioner",
                                sublayerid: 0,
                                nodes: [
                                    {
                                        id: "vk-restriktioner-extern-100",
                                        name: "< 1:100 000",
                                        layerid: "Restriktioner",
                                        sublayerid: 1
                                    },
                                    {
                                        id: "vk-restriktioner-extern-40",
                                        name: "< 1:40 000",
                                        layerid: "Restriktioner",
                                        sublayerid: 3
                                    }
                                ]
                            },
                            {
                                id: "vk-restriktioner-svea",
                                name: "Sveaskog",
                                layerid: "Restriktioner",
                                sublayerid: 4,
                                nodes: [
                                    {
                                        id: "vk-restriktioner-extern-100",
                                        name: "< 1:100 000",
                                        layerid: "Restriktioner",
                                        sublayerid: 5
                                    },
                                    {
                                        id: "vk-restriktioner-extern-50",
                                        name: "< 1:50 000",
                                        layerid: "Restriktioner",
                                        sublayerid: 6
                                    }
                                ]
                            },
                            {
                                id: "vk-restriktioner-ifl",
                                name: "IntactForestLandscape(< 1:100.000)",
                                layerid: "Restriktioner",
                                sublayerid: 7
                            },
                            {
                                id: "vk-restriktioner-artforekomster",
                                name: "Artförekomster",
                                layerid: "Restriktioner",
                                sublayerid: 9
                            }
                        ]
                    },
                    {
                        id: "vk-admingranser",
                        name: "Administrativa gränser",
                        nodes: [
                            {
                                id: "vk-admingrans-vk-omrade",
                                name: "Virkesköpsområden",
                                layerid: "VerkGemAdminGrans",
                                sublayerid: 0
                            },
                            {
                                id: "vk-admingrans-mo-omrade",
                                name: "Marknadsområden",
                                layerid: "VerkGemAdminGrans",
                                sublayerid: 1
                            },
                            {
                                id: "vk-admingrans-ro-omrade",
                                name: "Regioner",
                                layerid: "VerkGemAdminGrans",
                                sublayerid: 2
                            },
                            {
                                id: "vk-admingrans-po-omrade",
                                name: "Produktionsområden",
                                layerid: "VerkGemAdminGrans",
                                sublayerid: 3
                            },
                            {
                                id: "vk-admingrans-balansomraden",
                                name: "Balansområden",
                                layerid: "VerkGemAdminGrans",
                                sublayerid: 4
                            },
                            {
                                id: "vk-admingrans-planeraromraden",
                                name: "Planerarområde",
                                layerid: "VerkGemAdminGrans",
                                sublayerid: 7
                            },
                            {
                                id: "vk-admingrans-lld",
                                name: "LLD",
                                layerid: "VerkGemLLD",
                                sublayerid: 0
                            },
                            {
                                id: "vk-admingrans-lkf",
                                name: "LKF",
                                layerid: "VerkGemLKF",
                                sublayerid: 0
                            },
                            {
                                id: "vk-admingrans-fastigheter",
                                name: "Sveaskog Fastigheter",
                                layerid: "VerkGemFastigheter",
                                sublayerid: 0
                            },
                            {
                                id: "vk-admingrans-samfalligheter",
                                name: "Sveaskog Samfälligheter",
                                layerid: "VerkGemSamfalligheter",
                                sublayerid: 0
                            },
                            {
                                id: "vk-admingrans-samebyar",
                                name: "Samebyar",
                                layerid: "Renskotselomraden",
                                sublayerid: 0
                            }
                        ]
                    },
                    {
                        id: "vk-vagar",
                        name: "Vägar",
                        nodes: [
                            {
                                id: "vk-vagar-es",
                                name: "Vägar (ES)",
                                layerid: "Vagar",
                                sublayerid: 0
                            },
                            {
                                id: "vk-vagnamn",
                                name: "Vägnamn",
                                layerid: "Vagar",
                                sublayerid: 8
                            },
                            {
                                id: "vk-vagar-bas",
                                name: "Basvägar",
                                layerid: "Vagar",
                                sublayerid: 1
                            },
                            {
                                id: "vk-vagar-ovriga",
                                name: "Övriga vägar",
                                layerid: "Vagar",
                                sublayerid: 2
                            },
                            {
                                id: "vk-vagar-planerade",
                                name: "Planerade vägar",
                                layerid: "VFS_PlaneradVag",
                                sublayerid: 0
                            },
                            {
                                id: "vk-vagar-planerade-fardigstalld",
                                name: "Planerade vägar (färdigställd)",
                                layerid: "VFS_PlaneradVag",
                                sublayerid: 1
                            }
                        ]
                    },
                    {
                        id: "vk-forn-kultur",
                        name: "Forn- och kulturminnen",
                        nodes: [
                            {
                                id: "vk-forn-kultur-punkt-raä",
                                name: "Fornminne punkt RAÄ",
                                layerid: "FornKulturminnen",
                                sublayerid: 0
                            },
                            {
                                id: "vk-forn-kultur-linje-raä",
                                name: "Fornminne linje RAÄ",
                                layerid: "FornKulturminnen",
                                sublayerid: 1
                            },
                            {
                                id: "vk-forn-kultur-yta-raä",
                                name: "Fornminne yta RAÄ",
                                layerid: "FornKulturminnen",
                                sublayerid: 2
                            },
                            {
                                id: "vk-forn-kultur-skog-hist-punkt",
                                name: "Skog o historia, punkt",
                                layerid: "FornKulturminnen",
                                sublayerid: 3
                            },
                            {
                                id: "vk-forn-kultur-skog-hist-linje",
                                name: "Skog o historia, linje",
                                layerid: "FornKulturminnen",
                                sublayerid: 4
                            },
                            {
                                id: "vk-forn-kultur-skog-hist-yta",
                                name: "Skog o historia, yta",
                                layerid: "FornKulturminnen",
                                sublayerid: 5
                            }
                        ]
                    },
                    {
                        id: "vk-laserprodukter",
                        name: "Laserprodukter",
                        customLegend: {
                            component: LinkLegendComponent,
                            inputs: {
                                text: "Beskrivning laserprodukter",

                                url: "https://sveaskog.sharepoint.com/sites/Glantan/SiteCollectionDocuments/Forms" +
                                    "/AllItems.aspx?id=%2Fsites%2FGlantan%2FSiteCollectionDocuments%2FVirkesk%C3%B6p%2Fbeskrivning%5Frasterprodukter%2Epdf&viewid" +
                                    "=9ab85964%2D790a%2D4e46%2D910f%2De0223ad35cd7&parent=%2Fsites%2FGlantan%2FSiteCollectionDocuments%2FVirkesk%C3%B6p"
                            }
                        } as ICustomLegend,
                        nodes: [
                            {
                                id: "vk-laserprodukter-lutningsklass",
                                name: "Lutningsklass",
                                layerid: "Laserprodukter",
                                sublayerid: 2
                            },
                            {
                                id: "vk-laserprodukter-skuggad",
                                name: "Skuggad höjd",
                                layerid: "Laserprodukter",
                                sublayerid: 4
                            },
                            {
                                id: "vk-laserprodukter-trahojdraster",
                                name: "Trädhöjdsraster",
                                layerid: "Laserprodukter",
                                sublayerid: 3
                            },
                            {
                                id: "vk-laserprodukter-skuggadkronmodell",
                                name: "Skuggad kronmodell",
                                layerid: "Laserprodukter",
                                sublayerid: 1
                            },
                            {
                                id: "vk-laserprodukter-markvattenslu",
                                name: "Markfuktighet hela Sverige (SLU)",
                                layerid: "Laserprodukter",
                                sublayerid: 9
                            },
                            {
                                id: "vk-laserprodukter-markfuktighet",
                                name: "Markfuktighet egen skog",
                                layerid: "Laserprodukter",
                                sublayerid: 5,
                                nodes: [
                                    {
                                        id: "vk-laserprodukter-mkt-blot",
                                        name: "Mycket blötare",
                                        layerid: "Laserprodukter",
                                        sublayerid: 8
                                    },
                                    {
                                        id: "vk-laserprodukter-blot",
                                        name: "Blötare",
                                        layerid: "Laserprodukter",
                                        sublayerid: 7
                                    },
                                    {
                                        id: "vk-laserprodukter-normalt",
                                        name: "Normalt",
                                        layerid: "Laserprodukter",
                                        sublayerid: 6
                                    }
                                ]
                            },
                            {
                                id: "vk-laserprodukter-kronslutenhet",
                                name: "Kronslutenhet",
                                layerid: "Laserprodukter",
                                sublayerid: 0
                            }
                        ]
                    },
                    {
                        id: "vk-egen-skog",
                        name: "Egen skog",
                        nodes: [
                            {
                                id: "vk-egen-skog-atgarder",
                                name: "Åtgarder",
                                layerid: "Egen_skog",
                                sublayerid: 0,
                                nodes: [
                                    {
                                        id: "vk-egen-skog-atgarder-tillganglig",
                                        name: "Tillgänglig",
                                        layerid: "Egen_skog",
                                        sublayerid: 1,
                                        nodes: [
                                            {
                                                id: "vk-egen-skog-atgarder-till-fa",
                                                name: "Föryngringsavverkning",
                                                layerid: "Egen_skog",
                                                sublayerid: 2,
                                                nodes: [
                                                    {
                                                        id: "vk-laserprodukter-till-fa-ytter",
                                                        name: "Yttergräns",
                                                        layerid: "Egen_skog",
                                                        sublayerid: 3
                                                    },
                                                    {
                                                        id: "vk-laserprodukter-till-fa-fyllning",
                                                        name: "Fyllning",
                                                        layerid: "Egen_skog",
                                                        sublayerid: 4
                                                    }
                                                ]
                                            },
                                            {
                                                id: "vk-egen-skog-atgarder-till-ga",
                                                name: "Gallring",
                                                layerid: "Egen_skog",
                                                sublayerid: 5,
                                                nodes: [
                                                    {
                                                        id: "vk-laserprodukter-till-ga-ytter",
                                                        name: "Yttergräns",
                                                        layerid: "Egen_skog",
                                                        sublayerid: 6
                                                    },
                                                    {
                                                        id: "vk-laserprodukter-till-ga-fyllning",
                                                        name: "Fyllning",
                                                        layerid: "Egen_skog",
                                                        sublayerid: 7
                                                    }
                                                ]
                                            },
                                            {
                                                id: "vk-egen-skog-atgarder-till-ns",
                                                name: "NS-avverkning",
                                                layerid: "Egen_skog",
                                                sublayerid: 8,
                                                nodes: [
                                                    {
                                                        id: "vk-laserprodukter-till-ns-ytter",
                                                        name: "Yttergräns",
                                                        layerid: "Egen_skog",
                                                        sublayerid: 9
                                                    },
                                                    {
                                                        id: "vk-laserprodukter-till-ns-fyllning",
                                                        name: "Fyllning",
                                                        layerid: "Egen_skog",
                                                        sublayerid: 10
                                                    }
                                                ]
                                            },
                                            {
                                                id: "vk-egen-skog-atgarder-till-oa",
                                                name: "Övrig avverkning",
                                                layerid: "Egen_skog",
                                                sublayerid: 11,
                                                nodes: [
                                                    {
                                                        id: "vk-laserprodukter-till-oa-ytter",
                                                        name: "Yttergräns",
                                                        layerid: "Egen_skog",
                                                        sublayerid: 12
                                                    },
                                                    {
                                                        id: "vk-laserprodukter-till-oa-fyllning",
                                                        name: "Fyllning",
                                                        layerid: "Egen_skog",
                                                        sublayerid: 13
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        id: "vk-egen-skog-atgarder-ej-tillganglig",
                                        name: "Ej Tillgänglig",
                                        layerid: "Egen_skog",
                                        sublayerid: 14,
                                        nodes: [
                                            {
                                                id: "vk-egen-skog-atgarder-ej-till-fa",
                                                name: "Föryngringsavverkning",
                                                layerid: "Egen_skog",
                                                sublayerid: 15,
                                                nodes: [
                                                    {
                                                        id: "vk-laserprodukter-ej-till-fa-ytter",
                                                        name: "Yttergräns",
                                                        layerid: "Egen_skog",
                                                        sublayerid: 16
                                                    },
                                                    {
                                                        id: "vk-laserprodukter-ej-till-fa-fyllning",
                                                        name: "Fyllning",
                                                        layerid: "Egen_skog",
                                                        sublayerid: 17
                                                    }
                                                ]
                                            },
                                            {
                                                id: "vk-egen-skog-atgarder-ej-till-ga",
                                                name: "Gallring",
                                                layerid: "Egen_skog",
                                                sublayerid: 18,
                                                nodes: [
                                                    {
                                                        id: "vk-laserprodukter-ej-till-ga-ytter",
                                                        name: "Yttergräns",
                                                        layerid: "Egen_skog",
                                                        sublayerid: 19
                                                    },
                                                    {
                                                        id: "vk-laserprodukter-ej-till-ga-fyllning",
                                                        name: "Fyllning",
                                                        layerid: "Egen_skog",
                                                        sublayerid: 20
                                                    }
                                                ]
                                            },
                                            {
                                                id: "vk-egen-skog-atgarder-ej-till-ns",
                                                name: "NS-avverkning",
                                                layerid: "Egen_skog",
                                                sublayerid: 21,
                                                nodes: [
                                                    {
                                                        id: "vk-laserprodukter-ej-till-ns-ytter",
                                                        name: "Yttergräns",
                                                        layerid: "Egen_skog",
                                                        sublayerid: 22
                                                    },
                                                    {
                                                        id: "vk-laserprodukter-ej-till-ns-fyllning",
                                                        name: "Fyllning",
                                                        layerid: "Egen_skog",
                                                        sublayerid: 23
                                                    }
                                                ]
                                            },
                                            {
                                                id: "vk-egen-skog-atgarder-ej-till-oa",
                                                name: "Övrig avverkning",
                                                layerid: "Egen_skog",
                                                sublayerid: 24,
                                                nodes: [
                                                    {
                                                        id: "vk-laserprodukter-ej-till-oa-ytter",
                                                        name: "Yttergräns",
                                                        layerid: "Egen_skog",
                                                        sublayerid: 25
                                                    },
                                                    {
                                                        id: "vk-laserprodukter-ej-till-oa-fyllning",
                                                        name: "Fyllning",
                                                        layerid: "Egen_skog",
                                                        sublayerid: 26
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                id: "vk-egen-skog-naturhansyn",
                                name: "Naturhänsyn",
                                layerid: "Egen_skog",
                                sublayerid: 27,
                                nodes: [
                                    {
                                        id: "vk-egen-skog-naturhansyn-detalj",
                                        name: "Detaljhänsyn",
                                        layerid: "Egen_skog",
                                        sublayerid: 28,
                                        nodes: [
                                            {
                                                id: "vk-egen-skog-naturhansyn-detalj-punkter",
                                                name: "Punkter",
                                                layerid: "Egen_skog",
                                                sublayerid: 29
                                            },
                                            {
                                                id: "vk-egen-skog-naturhansyn-detalj-linjer",
                                                name: "Linjer",
                                                layerid: "Egen_skog",
                                                sublayerid: 30
                                            },
                                            {
                                                id: "vk-egen-skog-naturhansyn-detalj-yta-ytter",
                                                name: "Ytor yttergräns",
                                                layerid: "Egen_skog",
                                                sublayerid: 31
                                            },
                                            {
                                                id: "vk-egen-skog-naturhansyn-detalj-yta-fyll",
                                                name: "Ytor fyllning",
                                                layerid: "Egen_skog",
                                                sublayerid: 32
                                            }
                                        ]
                                    },
                                    {
                                        id: "vk-egen-skog-naturhansyn-naturvardskogar",
                                        name: "Naturvårdsskogar",
                                        layerid: "Egen_skog",
                                        sublayerid: 33
                                    }
                                ]
                            },
                            {
                                id: "vk-egen-skog-drivningspunkter",
                                name: "Drivningspunkter",
                                layerid: "Egen_skog",
                                sublayerid: 34,
                                nodes: [
                                    {
                                        id: "vk-egen-skog-drivningspunkter-sub",
                                        name: "Drivningspunkter",
                                        layerid: "Egen_skog",
                                        sublayerid: 35
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        id: "vk-arbetsorder",
                        name: "Arbetsorder",
                        visible: false,
                        nodes: [
                            {
                                id: "vk-stina-korstrak",
                                name: "Stina körstråk",
                                layerid: "StinaKorstrak",
                                visible: false,
                                nodes: [
                                    {
                                        id: "vk-stina-korstrak-backstrak-spokstrak",
                                        name: "Backstråk och spökstråk",
                                        layerid: "StinaKorstrak",
                                        sublayerid: 0,
                                        visible: false
                                    },
                                    {
                                        id: "vk-stina-korstrak-skotare",
                                        name: "Körstråk Skotare",
                                        layerid: "StinaKorstrak",
                                        sublayerid: 1,
                                        visible: false,
                                        nodes: [
                                            {
                                                id: "vk-stina-korstrak-skotare-korstrak",
                                                name: "Körstråk skotare",
                                                layerid: "StinaKorstrak",
                                                sublayerid: 2
                                            },
                                            {
                                                id: "vk-stina-korstrak-skotare-ytterlinje",
                                                name: "Körstråksyta skotare ytterlinje",
                                                layerid: "StinaKorstrak",
                                                sublayerid: 3
                                            },
                                            {
                                                id: "vk-stina-korstrak-skotare-fyllning",
                                                name: "Körstråksyta skotare fyllning",
                                                layerid: "StinaKorstrak",
                                                sublayerid: 4
                                            }
                                        ]
                                    },
                                    {
                                        id: "vk-stina-korstrak-skordare",
                                        name: "Körstråk Skördare",
                                        layerid: "StinaKorstrak",
                                        sublayerid: 5,
                                        visible: false,
                                        nodes: [
                                            {
                                                id: "vk-stina-korstrak-skordare-korstrak",
                                                name: "Körstråk skördare",
                                                layerid: "StinaKorstrak",
                                                sublayerid: 6
                                            },
                                            {
                                                id: "vk-stina-korstrak-skordare-ytterlinje",
                                                name: "Körstråksyta skördare ytterlinje",
                                                layerid: "StinaKorstrak",
                                                sublayerid: 7
                                            },
                                            {
                                                id: "vk-stina-korstrak-skordare-fyllning",
                                                name: "Körstråksyta skördare fyllning",
                                                layerid: "StinaKorstrak",
                                                sublayerid: 8
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                id: "vk-stina-grotpunkter",
                                name: "Stina Grotpunkter",
                                layerid: "StinaGrotpunkter",
                                sublayerid: 0
                            },
                            {
                                id: "vk-stina-hansyn",
                                name: "Stina hänsyn",
                                layerid: "StinaHansyn",
                                sublayerid: 0,
                                nodes: [
                                    {
                                        id: "vk-stina-hansyn-naturpunkt",
                                        name: "Naturhänsynspunkt",
                                        layerid: "StinaHansyn",
                                        sublayerid: 1
                                    },
                                    {
                                        id: "vk-stina-hansyn-punkt",
                                        name: "Hänsynspunkt",
                                        layerid: "StinaHansyn",
                                        sublayerid: 2
                                    },
                                    {
                                        id: "vk-stina-hansyn-linje",
                                        name: "Hänsynslinje",
                                        layerid: "StinaHansyn",
                                        sublayerid: 3
                                    },
                                    {
                                        id: "vk-stina-hansyn-ytterlinje",
                                        name: "Hänsynsyta ytterlinje",
                                        layerid: "StinaHansyn",
                                        sublayerid: 4
                                    },
                                    {
                                        id: "vk-stina-hansyn-fyllning",
                                        name: "Hänsynsyta fyllning",
                                        layerid: "StinaHansyn",
                                        sublayerid: 5
                                    }
                                ]
                            },
                            {
                                id: "vk-stina-egenritade",
                                name: "Stina egenritade objekt",
                                layerid: "StinaEgenritadeObjekt",
                                nodes: [
                                    {
                                        id: "vk-stina-egenritade-punkt",
                                        name: "Egenritad punkt",
                                        layerid: "StinaEgenritadeObjekt",
                                        sublayerid: 0
                                    },
                                    {
                                        id: "vk-stina-egenritade-linje",
                                        name: "Egenritad linje",
                                        layerid: "StinaEgenritadeObjekt",
                                        sublayerid: 1
                                    },
                                    {
                                        id: "vk-stina-egenritade-yta-ytterlinje",
                                        name: "Egenritad yta ytterlinje",
                                        layerid: "StinaEgenritadeObjekt",
                                        sublayerid: 2
                                    },
                                    {
                                        id: "vk-stina-egenritade-yta-fyllning",
                                        name: "Egenritad yta fyllning",
                                        layerid: "StinaEgenritadeObjekt",
                                        sublayerid: 3
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        id: "vk-ovriga",
                        name: "Övriga",
                        nodes: [
                            {
                                id: "vk-satellitbilder",
                                name: "Satellitbilder",
                                layerid: "Satellitbilder",
                                sublayerid: 0
                            },
                            {
                                id: "vk-smittadzon",
                                name: "Smittad zon",
                                layerid: "smittad_zon_sjv",
                                sublayerid: 0
                            },
                            {
                                id: "vk-ArtrikVagmiljo",
                                name: "Artrik vägmiljö",
                                layerid: "ArtrikVagmiljo",
                                sublayerid: 2
                            },
                            {
                                id: "vk-dronarbilder",
                                name: "Drönarortofoton",
                                nodes: [
                                    {
                                        id: "vk-dronarbilder-index",
                                        name: "Index",
                                        layerid: "Drone",
                                        sublayerid: 0
                                    },
                                    {
                                        id: "vk-dronarbilder-bilder",
                                        name: "Drönarbilder",
                                        layerid: "Drone",
                                        sublayerid: 1
                                    }
                                ]
                            },
                            {
                                id: "vk-vindkraftverk",
                                name: "Vindkraftverk",
                                nodes: [
                                    {
                                        id: "vk-projektomrade-for-vindkraft",
                                        name: "Projektområde för vindkraft",
                                        layerid: "VerkGemFaktaExternVindkraft",
                                        sublayerid: 0
                                    },
                                    {
                                        id: "vk-belastningar-vindkraft",
                                        name: "Vindkraft",
                                        layerid: "VerkGemFaktaBelastningar",
                                        sublayerid: 13
                                    }
                                ]
                            },
                            {
                                // wms lager då wms identifierar lager medhjälp av namn är det viktigt att sublayername anges,
                                // tyvärr måste även sublayerid fortsatt oxå anges även om detta bara är ett löpnummer som man själv anger här i konfigurationen.
                                id: "vk-orto",
                                name: "Historiska ortofoton",
                                nodes: [
                                    {
                                        id: "vk-orto-60",
                                        name: "Ref. år 1960",
                                        layerid: "Historto",
                                        sublayerid: 1,
                                        sublayerName: "OI.Histortho_60"
                                    },
                                    {
                                        id: "vk-orto-75",
                                        name: "Ref. år 1975",
                                        layerid: "Historto",
                                        sublayerid: 2,
                                        sublayerName: "OI.Histortho_75"
                                    }
                                ]
                            },
                            {
                                id: "vk-orto-ir",
                                name: "IR ortofoto",
                                layerid: "Infrarodorto",
                                sublayerid: 3,
                                sublayerName: "metria:orto_ir"
                            }
                        ]
                    },
                    {
                        id: "vk-sks-avverkningsanmalningar",
                        name: "SKS Avverkningsanmälningar",
                        nodes: [
                            {
                                id: "vk-sks-avverkningsanmalan",
                                name: "Avverkningsanmälan",
                                layerid: "SKS_Avverkningsanmalningar",
                                sublayerid: 0
                            },
                            {
                                id: "vk-sks-utford-avverkning",
                                name: "Utförd avverkning",
                                layerid: "SKS_UtfordAvverkning",
                                sublayerid: 1
                            }
                        ]

                    }
                ]
        },
        {
            id: "justaraRutt",
            config: [
                {
                    id: "jr-vagar",
                    name: "Vägar",
                    nodes: [
                        {
                            id: "jr-vagar-es",
                            name: "Vägar (ES)",
                            layerid: "Vagar",
                            sublayerid: 0
                        },
                        {
                            id: "jr-vagnamn",
                            name: "Vägnamn",
                            layerid: "Vagar",
                            sublayerid: 8
                        },
                        {
                            id: "jr-vagar-bas",
                            name: "Basvägar",
                            layerid: "Vagar",
                            sublayerid: 1
                        },
                        {
                            id: "jr-vagar-ovriga",
                            name: "Övriga vägar",
                            layerid: "Vagar",
                            sublayerid: 2
                        }
                    ]
                },
                {
                    id: "jr-ovriga",
                    name: "Övriga",
                    nodes: [
                        {
                            id: "jr-smittadzon",
                            name: "Smittad zon",
                            layerid: "smittad_zon_sjv",
                            sublayerid: 0
                        }
                    ]
                }
            ]
        },
        {
            id: "virkeskop-fastigheter",
            config: [
                {
                    id: "virkeskop-fastigheter-metriafastighetsgranser",
                    name: "Metria Fastighetsgränser",
                    layerid: "MetriaFastighetsgranser",
                    nodes: [
                        {
                            id: "virkeskop-fastigheter-metria-fastigheter",
                            name: "Fastigheter",
                            layerid: "MetriaFastighetsgranser",
                            sublayerid: 0
                        }
                    ]
                }
            ]
        }
    ];
}
